export default function CoinCardSkeleton() {
  return (
    <div className="relative bg-foreground border-2 border-primaryborder rounded-2xl p-6 flex flex-col">
      <div className="flex items-start justify-between mb-2">
        <div className="flex flex-col md:h-auto items-start gap-5">
          <div className="w-[100px] h-[100px] rounded-full bg-gradient-button-dark animate-pulse" />
          <div className="">
            <div className="h-6 w-32 mb-2 bg-gradient-button-dark animate-pulse rounded-md " />
            <div className="h-4 w-64 bg-gradient-button-dark animate-pulse rounded-md" />
          </div>
        </div>
        <div className="absolute top-6 right-6 flex space-x-2 rounded-full p-2 z-10">
          <div className="w-6 h-6 rounded-full bg-gradient-button-dark animate-pulse" />
          <div className="w-6 h-6 rounded-full bg-gradient-button-dark animate-pulse" />
          <div className="w-6 h-6 rounded-full bg-gradient-button-dark animate-pulse" />
          <div className="w-6 h-6 rounded-full bg-gradient-button-dark animate-pulse" />
        </div>
      </div>

      <div className="mt-auto pt-4">
        <div className="flex justify-between items-center mb-2">
          <div className="h-6 w-20 bg-gradient-button-dark animate-pulse rounded-md" />
          <div className="h-4 w-24 bg-gradient-button-dark animate-pulse rounded-md" />
        </div>
        <div className="w-full h-2 rounded-full bg-gradient-button-dark animate-pulse" />
      </div>
    </div>
  );
} 